import React from 'react';

interface Props {
  stroke?: string;
  width?: string;
  height?: string;
  className?: string;
}

export default function InfoIcon({ stroke = '#A729D2', width = '18', height = '18', className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <circle cx="9" cy="9" r="7.5" stroke={stroke} strokeWidth="1.5" />
      <path
        d="M9 8.5V12.5M9 6.5H9.01"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
